import React, {useState} from 'react'
import farmerContext from './farmerContext'
import axios from 'axios'


const FarmerState = props => {


    const [farmer, setFarmer] = useState({

        loading: "d-flex ",
        page_loading: "d-flex ",
        farmTypes: [],
        farmStates: [],
        farmLgas: [],
        equipments: [],
        userBank: [],
        equipmentServices: [],
        equipmentRequests: [],
        userInfo: null,
        farms: [],
        banks: [],
        stats: [],
        current: null,
        purchaseData: [],
        error: null,
        message: {
            msg: "",
            msg_options: ""
        },
        logged_in: localStorage.getItem('al2'),
        side_bar_toggle: ""
        // logged_in: false
    })

    const url = 'https://hailing-backend-app.azurewebsites.net/';
    // const url = 'https://hailing-backend.herokuapp.com/';
    // const url = 'http://127.0.0.1:9900/';
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let authorization;
    if (userInfo !== null) authorization = userInfo.authorization


    //Set up axios headers
    let authAxios = axios.create({
        headers: {
            'Content-Type': 'multipart/form-data',
            'authorization': authorization
        },
        validateStatus: () => true
    })

    //Get Farm Equipments
    const getEquipments = async id => {
        try {
            const res = await authAxios.get(url + `user/farmer/get_equipment_service_equipments/${id}`)
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    equipments: res.data.data
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    //Get Farm Equipment Service
    const getEquipmentServices = async () => {
        try {
            const res = await authAxios.get(url + 'user/farmer/get_equipment_service_settings')
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    equipmentServices: res.data.data
                })
            )
            return res;
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
            return error;
        }
    }

    //Get Farm Equipment Requests
    const getEquipmentRequests = async () => {
        try {
            const res = await authAxios.get(url + 'user/farmer/equipment_requests')
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    equipmentRequests: res.data.data
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    const getFarmerStats = async () => {
        try {
            const res = await authAxios.get(url + 'statistics/farmer/dash_statistics')
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    stats: res.data.data
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    const createEquipmentRequest = async (purchase_data) => {
        try {
            const res = await authAxios.post(url + 'user/farmer/generate_invoice', purchase_data)
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    purchaseData: res.data.data,
                    success: true,
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    //work around for paystack callback url
    const log_farmer_equipment_request = (payment_reference) => {
        authAxios.get(url + 'user/farmer/request_equipment/' + payment_reference)
    }

    const addBank = async (bankDetails) => {
        try {
            const res = await authAxios.post(url + 'generic/add_bank', bankDetails)
            if (res.request.status === 201) {
                setFarmer(prevState => ({
                        ...prevState,
                        loading: false,
                        success: true,
                    })
                )
            }
            handle_response(res)
        } catch (error) {
            network_error(error)
        }
    }

    const updateBank = async (bank_details) => {
        try {
            const res = await authAxios.put(`${url}generic/update_bank`, bank_details)
            setFarmer(prevState => ({
                    ...prevState,
                    userBank: res.data.data
                })
            )
            handle_response(res);
            return res;
        } catch (error) {
            network_error(error)
        }
    }

    //Update Profile
    const updateProfile = async (user) => {

        try {
            return await authAxios.put(
                url + 'auth/user/update/profile/',
                user
            ).then(res => {
                handle_response(res);
                return res;

            }).catch(res => {
                handle_response(res);
                return res;
            })
        } catch (error) {
            network_error(error)
        }
    }

    const updateFarmerPassword = async (password) => {
        try {
            const res = await authAxios.put(`${url}auth/user/update/password`, password)
            handle_response(res)
            return res;
        } catch (error) {
            network_error(error);
            return error;
        }
    }

    const uploadImage = async (image) => {
        try {
            const res = await authAxios.put(`${url}auth/user/update/picture`, image)
            handle_response(res)
            return res;
        } catch (error) {
            network_error(error)
        }
    }

    //Add Farm
    const addFarm = async farm => {

        try {
            return await authAxios.post(
                `${url}user/farmer/add_farm`,
                farm
            ).then(res => {
                setFarmer(prevState => ({
                        ...prevState,
                        farms: [], //clear farm
                    })
                )
                handle_response(res)
                return res;

            }).catch(res => {
                handle_response(res)
                return res;
            })
        } catch (error) {
            network_error(error)
        }
    }
    //Update Farm
    const updateFarm = async (farm, farm_id) => {

        try {
            return await authAxios.put(
                `${url}user/farmer/edit_farm/${farm_id}`,
                farm
            ).then(res => {

                if (res.request.status === 422 || res.request.status === 400) {
                    setFarmer(prevState => ({
                            ...prevState,
                        })
                    )
                }
                if (res.request.status === 201) {
                    setFarmer(prevState => ({
                            ...prevState,
                            farms: [], //empty farm so other components can pick updated data
                        })
                    )
                }
                handle_response(res)
                return res;

            }).catch(res => {
                handle_response(res)
                return res;
            })
        } catch (error) {
            network_error(error)
            return error;
        }

    }

    //Delete Farm
    const deleteFarm = async id => {
        try {
            return await authAxios.put(
                `${url}user/farmer/remove_farm/${id}`,
            ).then(res => {
                setFarmer(prevState => ({
                        ...prevState,
                        farms: farmer.farms.filter(farm => farm.id !== id),
                    })
                )
                handle_response(res)
                return res;

            }).catch(res => {
                handle_response(res)
                return res;
            })
        } catch (error) {
            network_error(error)
        }

    }

    //Get Farm Type
    const getFarmType = async () => {
        try {
            const res = await authAxios.get(`${url}user/farmer/get_farm_type`)
            setFarmer(prevState => ({
                    ...prevState,
                    farmTypes: res.data.data
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    //Get States
    const getStates = async () => {
        try {
            const res = await axios.get(`${url}generic/get_states`)
            setFarmer(prevState => ({
                    ...prevState,
                    farmStates: res.data.data,
                })
            )
            return res;
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
            return error;
        }
    }
    //Get Banks
    const getBanks = async () => {
        try {
            const res = await axios.get(`${url}generic/get_banks`)
            setFarmer(prevState => ({
                    ...prevState,
                    banks: res.data.data.data,
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )

        }
    }

    //Get User Bank
    const getUserBank = async () => {
        try {
            const res = await authAxios.get(`${url}generic/get_user_bank`)
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    userBank: res.data.data,
                })
            )
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )

        }
    }

    //Get LGA'S
    const getLga = async state_id => {
        try {
            const res = await axios.get(`${url}generic/get_lga/${state_id}`)
            setFarmer(prevState => ({
                    ...prevState,
                    farmLgas: res.data.data,
                })
            )
            return res;
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
            return error;
        }
    }

    //Get Farms
    const getFarms = async () => {
        try {
            const res = await authAxios.get(`${url}user/farmer/get_farms`)
            setFarmer(prevState => ({
                    ...prevState,
                    farms: res.data.data,
                    loading: false
                })
            )
            return res.data.data;
        } catch (error) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    error: error.response && error.response.data.detail
                        ? error.response.data.detail
                        : error.message,
                })
            )
        }
    }

    //Set Current Farm
    const setCurrent = farm => {
        setFarmer(prevState => ({
                ...prevState,
                current: farm
            })
        )
    }

    //Clear Current Farm
    const clearCurrent = () => {
        setFarmer(prevState => ({
                ...prevState,
                current: null
            })
        )
    }

    const clearAlert = () => {
        setFarmer(prevState => ({
                ...prevState,
                message: {
                    msg: "",
                    msg_options: {
                        type: '',
                        position: ""
                    }
                }
            })
        )
    }

    //Set Loading
    const setLoading = () => {
        setFarmer(prevState => ({
                ...prevState,
                page_loading: "d-flex ",
                loading: "d-flex ",
            })
        )
    }

    const clearPageLoading = () => {
        setFarmer(prevState => ({
                ...prevState,
                page_loading: "d-none ",
                loading: "d-none ",
            })
        )
    }

    const toggle_sidebar = () => {
        if (farmer.side_bar_toggle === "") {
            setFarmer(prevState => ({
                    ...prevState,
                    side_bar_toggle: "toggled"
                })
            )
        } else {
            setFarmer(prevState => ({
                    ...prevState,
                    side_bar_toggle: ""
                })
            )
        }

    }

    const handle_response = (res) => {
        if (res.request.status === 200 || res.request.status === 201) {
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    success: true,
                    message: {
                        msg: `${res.data.message}`,
                        msg_options: {
                            type: 'success',
                            position: "bottom right"
                        }
                    },
                })
            )
        } else if (res.request.status > 399) {
            setFarmer(prevState => ({
                    ...prevState,
                    message: {
                        msg: `${JSON.parse(res.request.response).message}`,
                        msg_options: {
                            type: 'error',
                            position: "bottom right"
                        }
                    },
                })
            )
        }
    }

    const network_error = (res) => {
        if (res.request.status === 0) {
            console.log("no response");
            setFarmer(prevState => ({
                    ...prevState,
                    loading: false,
                    message: {
                        msg: 'network error, please check your internet connection!',
                        msg_options: {
                            type: 'error',
                            position: "bottom left"
                        }
                    }
                })
            )
        }
    }


    return <farmerContext.Provider
        value={{
            farmer,
            setLoading,
            getFarmType,
            getStates,
            getLga,
            getFarms,
            createEquipmentRequest,
            getEquipmentRequests,
            getEquipmentServices,
            getEquipments,
            addFarm,
            setCurrent,
            clearCurrent,
            updateFarm,
            deleteFarm,
            updateProfile,
            toggle_sidebar,
            clearAlert,
            clearPageLoading,
            getBanks,
            getUserBank,
            addBank,
            updateFarmerPassword,
            updateBank,
            uploadImage,
            log_farmer_equipment_request,
            getFarmerStats
        }}>
        {props.children}
    </farmerContext.Provider>
}

export default FarmerState;